<template>
  <!-- 学视频 -->
  <div>
    <div class="sy-xsp">
      <!-- <div class="sy-xsp" v-if="false"> -->
      <div class="sy-xsptit">
        <span>学视频</span>
      </div>
      <el-tabs
        v-model="activeName"
        :tab-position="tabPosition"
        style="height: 330px"
        class="sy-spnr"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="item in videoData"
          :key="item.id"
          class="video-con clearfix spnr-crsp"
        >
        <span slot="label" :title="item.videoTitle">{{ item.videoTitle }}</span>
          <div class="video-container" v-if="false">
            <template v-if="!isLogin">
              <!-- 封面图 -->
              <img :src="item.bigimagehttpurl" alt="" class="poster" />
              <div class="video-controls">
                <img
                  src="../../assets/images/player.png"
                  alt=""
                  class="play-icon" @click="login()"
                />{{ item.videoTitle }}
              </div>
            </template>
            <video v-else controls :src="item.videoLink" width="458.54" height="267" style="object-fit:cover;"></video>
          </div>
          <div class="video-container" v-if="false">
            <span class="play-icon"></span>
            <img :src="item.bigimagehttpurl" alt="" />
            <video
              :src="item.videoLink"
              width="458.54"
              height="267"
              style="object-fit: cover"
            ></video>
            <!-- <video id="video1" :src="item.videoLink" :poster="`${item.bigimagehttpurl}`"  width="458.54" height="267" style="object-fit:cover;"></video> -->
          </div>
          <div class="spnr-detail">
            <h4 :title="item.videoTitle">{{ item.videoTitle }}</h4>
            <span class="tag-title">主讲专家:</span>
            <p>{{ videoDetailData.expertName }}</p>
            <p class="text-ellipsis" :title="videoDetailData.expertTitle">
              {{ videoDetailData.expertTitle }}
            </p>
            <span class="tag-title">视频简介:</span>
            <el-tooltip
              class="video-tooltip"
              effect="light"
              :content="item.videoIntroduce"
              placement="bottom"
            >
              <el-button>{{
                curStr(item.videoIntroduce, 75)
              }}</el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
        
  <div class="video-container" v-if="false">
		<!-- <div id="video"></div> -->
    <div
      id="video"
      :class="{
        'video-con-l': true,
        por: true,
        small: true
      }"
    >
      <img :src="item.bigimagehttpurl" alt="" class="pic" />
      <div class="video-con-l-con poa txt-overflow">
        <img src="../../assets/images/player.png" alt="" class="player small" />{{ item.videoTitle }}
      </div>
    </div>
  </div>
        <VideoContainer
        ref="videoContainer"
            :item="item"
            :isHome="true"
          ></VideoContainer>
    </div>
  </div>
</template>
<script>
import VideoContainer from "../Video.vue";
import Cookies from 'js-cookie'
export default {
  name: "StudyVideo",
  props: ["downloadUrl", "urlPath", "v_type", "isWeb"],
  components: {
    VideoContainer,
  },
  data() {
    return {
      //习近平新时代中国特色社会主义思想概论
      videoSurvey: {}, //概论左侧
      videoDetailDataSurvey: {}, //概论详情

      //习近平新时代中国特色社会主义思想的方法论
      videoMethods: {}, //方法论左侧
      videoDetailDataMethods: {}, //方法论详情

      videoData: [], //视频课程
      videoDetailData: {}, //视频详情数据
      videoDetailLoading: false, //加载中
      tabPosition: "left",
      activeName: "0",
      isLogin: false,
      item:{},
      total:0, // 总条数
      

    };
  },
  created() {
    this.getVideoData(); //获取视频课程 打开页面请求
    this.isLogin = !!Cookies.get("user_name");
  },
  methods: {
    getVideoData(total) {
      this.axios
        .post("data/custom/videolist", {
          uid: "35128599-fb91-4ca2-a52a-16ad7ec1e41a",
          pageNum: 1,
          pageSize: total || 10,
        })
        .then((res) => {
          if (res.status == 200) {
            this.total = res.data.total
            if(this.total > 10 && !total) return this.getVideoData(this.total)
            this.videoData = res.data.rows;
            if (!this.videoData.length) return;
            this.item = this.videoData[Number(this.activeName)]
            this.getVideoDetailData();
            // debugger
            this.$refs.videoContainer.changeMedia(this.item)
            // this.loadCKplayer(this.item)
          } else {
            this.$message.error("获取视频课程失败！");
          }
        });
    },
    getVideoDetailData() {
      this.videoDetailData = this.videoData[Number(this.activeName)].speakerInfo;
    },
    //视频课程切换
    handleClick(val) {
      this.getVideoDetailData();
      this.$refs.videoContainer.changeMedia(this.videoData[Number(this.activeName)])
    },
    login() {
      this.$message.warning("请登录后观看！");
    },
    //截取字符串
    curStr(str, len) {
      //摘要截取200字
      //此处加一层判断 防止获取不到length
      if (str) {
        //\s表示正则匹配字符串中的空字符串
        str = str.replace(/\s/g, "");
        if (str.length <= len) {
          return str;
        } else {
          return str.substring(0, len) + "..."; //substring()提取字符串介于两个指定下表之间的字符
        }
      }
    },






  },
};
</script>
<style lang="scss" scoped>
.pt56 {
  padding-top: 56px;
}
.sy-spnr{
  
  background: url(../../assets/images/wg_bg.png) no-repeat 0 10px;
    background-size: 100% calc(100% - 20px);
}
::v-deep {
  .el-tabs--left {
    .el-tabs__nav-wrap.is-left::after {
      content: none;
    }
    .el-tabs__active-bar.is-left {
      display: none;
    }

    .el-tabs__item {
      font-size: 16px;
      &:hover {
        color: #de1c26;
      }
      &.is-active {
        background: linear-gradient(90deg, #bd1a2d 0.09%, #ec0e0e 100%);
        color: #fff;
      }
      &.is-left {
        text-align: center;
        padding-left: 14px;
        padding-right: 14px;
        max-width: 348px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .el-tabs__header.is-left {
      margin-right: 0;
      position: relative;
      &::before,
      &::after {
        content: "";
        position: absolute;
        right: -10px;
        width: 0;
        height: 0;
        border-right: 10px solid transparent;
      }
      &::before {
        top: 0;
        border-bottom: 10px solid #cc9a9d;
      }
      &::after {
        bottom: 0;
        border-top: 10px solid #cc9a9d;
      }
    }
  }
  .el-tabs__header {
    background: linear-gradient(
      89.77deg,
      #ffdfd4 0.19%,
      #fff3ec 45.32%,
      #ffdfd5 99.79%
    );
  }
  .el-tabs__content {
    height: 100%;
    width: 373px;
    float:right;
  }
  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    color: #d5141e;
    font-size: 20px;
  }

  .el-button.el-tooltip {
    background: transparent;
    border: none;
    display: inline;
    white-space: inherit;
    line-height: 28px;
    text-align: justify;
    padding: 0;
    cursor: text;
    font-size: 16px;
    &:hover {
      color: #383636;
    }
  }
}

// 学习视频
.video-wrap {
  .video1-title {
    font-size: 18px;
    color: #ac0101;
    height: 46px;
    line-height: 46px;
    padding-left: 20px;
    background: url("../../assets/images/video1-title.png") center 0 no-repeat;
    margin-top: 26px;
    margin-bottom: 45px;
  }
  .video {
    padding-top: 14px;
    .video-con {
      // padding-top: 27px;
    }
    .carousel-con {
      width: 1042px;
      margin: 0 auto;
      & > p {
        top: 0;
        width: 300px;
        height: 295px;
        z-index: 10;
      }
      .mask-l {
        left: 0;
      }
      .mask-r {
        right: 0;
      }
    }
    .video-con-r {
      width: 100%;
      height: 60px;
      margin-bottom: 25px;
    }
    .video-con-detail {
      padding-top: 26px;
      padding-bottom: 13px;
      .video-con-detail-l {
        width: 587px;
        background-color: #fdf8f3;
        box-shadow: 0px 3px 4px 0px rgba(231, 232, 237, 0.35);
        border: solid 1px #eee;
        box-sizing: border-box;
        padding: 30px 23px 24px 18px;
        height: 372px;
        .brief {
          line-height: 28px;
          color: #666;
          font-size: 14px;
          span {
            color: #bc2221;
            font-size: 16px;
            font-weight: bold;
          }
        }
        .brief-con {
          height: 142px;
        }
        h3 {
          margin-top: 17px;
          height: 30px;
          line-height: 30px;
          color: #fff;
          border-bottom: dashed 1px #eac5b2;
          font-size: 16px;
          margin-bottom: 6px;
          span {
            width: 73px;
            background-color: #bc2221;
            text-align: center;
            display: inline-block;
          }
        }
        .gx_l_data {
          li {
            border-bottom: 1px dashed #dcdcdc;
            width: 100%;
            margin-right: 0;
            height: 29px;
            line-height: 29px;
            font-size: 13px;
            a {
              background: url("../../assets/images/arrow-small.png") 4px center
                no-repeat;
              padding-left: 19px;
              // width: 92%;
            }
            span {
              width: 120px;
            }
          }
        }
      }
      .video-con-detail-r {
        .gx_l_data {
          li {
            a {
              width: calc(100% - 160px);
            }
          }
        }
        .brief-con {
          height: 84px;
        }
      }
    }
    .el-carousel--horizontal {
      overflow: hidden;
    }
  }
  .video1 {
    .video {
      padding-top: 0;
      padding-bottom: 10px;
      .video-con {
        padding-top: 0;
      }
      .video-con-l {
        width: 446px;
        height: 300px;
        position: absolute;
        .video-con-l-con {
          font-weight: normal;
        }
        .name {
          font-size: 14px;
          padding-left: 6px;
        }
        .time {
          font-size: 14px;
        }
        .pic {
          width: 446px;
          height: 300px;
        }
      }
    }
    .video1-con {
      margin-right: 1px;
      width: 731px;
      height: 298px;
      background-color: #fff;
      box-shadow: -1px 5px 5px 0px rgba(204, 200, 200, 0.75);
      border: solid 1px #eee;
      border-left: none;
      .bg {
        background: url("../../assets/images/video1-title2.png") 0 0 no-repeat;
        height: 56px;
        position: absolute;
        left: -22px;
        width: 753px;
        padding-left: 41px;
        line-height: 32px;
        font-size: 16px;
        color: #ac0101;
      }
      .video1-con-con {
        display: flex;
        justify-content: space-around;
      }
      .video1-con-con-list {
        width: calc(50% - 35px);
        padding-left: 25px;
        padding-right: 10px;
        .title-list {
          height: 34px;
          font-size: 15px;
          color: #ac0101;
          background: url("../../assets/images/icon.png") 0 0 no-repeat;
          padding-left: 28px;
          span {
            border-bottom: 2px solid #ac0101;
            line-height: 30px;
            display: inline-block;
          }
        }
        .abstract {
          padding-left: 28px;
          padding-top: 8px;
          font-size: 14px;
          color: #666;
          line-height: 26px;
          padding-bottom: 7px;
          height: 52px;
          .el-button {
            background: transparent;
            border: none;
            display: inline;
            white-space: inherit;
            line-height: 28px;
            color: #666;
            text-align: justify;
            padding: 0;
            cursor: text;
          }
        }
        .gx_l_data {
          padding-left: 9px;
          padding-top: 8px;
          height: 84px;
          li {
            width: calc(100% - 19px);
            line-height: 28px;
            height: 28px;
            a {
              width: 100%;
              background: url("../../assets/images/arrow-small.png") 0 center
                no-repeat;
              padding-left: 19px;
              color: #666;
              font-size: 14px;
              &:hover {
                color: #f70;
              }
            }
          }
        }
      }
    }
  }
}

//视频课程轮播
.video-con-r ::v-deep {
  .el-carousel__container {
    height: 60px;
  }
  .el-carousel__item .carousel {
    width: 96%;
    margin: 0 auto;
    li {
      cursor: pointer;
      width: 25%;
      float: left;
      // transition: transform .3s;
      // &:hover{
      // 	transform:scale(1.1);
      // }
      img {
        width: 181px;
        height: 85px;
        display: block;
      }
      &.cur {
        p {
          color: #fff !important;
          background: #ac0101 !important;
        }
      }
    }
    .carousel-item-r {
      width: 100%;
      height: 60px;
      box-sizing: border-box;
      line-height: 22px;
      text-align: center;
      float: none;
      .p1 {
        font-size: 15px;
        color: #333;
        margin: 0 6px;
        background-color: #fef8f1;
        border-radius: 3px;
        padding: 8px 16px;
        height: 44px;
        // text-align:left;
      }
      .ph44 {
        line-height: 44px;
      }
      .p2 {
        font-size: 12px;
        color: #666;
        span:nth-child(1) {
          margin-right: 13px;
        }
      }
    }
  }
  .el-carousel__arrow--left {
    left: 0;
    background: url("../../assets/images/arrow-left.png") 0 center no-repeat;
    width: 20px;
    i {
      display: none;
    }
    &:hover {
      background: url("../../assets/images/arrow-left-cur.png") 0 center
        no-repeat;
    }
  }
  .el-carousel__arrow--right {
    right: 0;
    background: url("../../assets/images/arrow-right.png") right center
      no-repeat;
    width: 20px;
    i {
      display: none;
    }
    &:hover {
      background: url("../../assets/images/arrow-right-cur.png") right center
        no-repeat;
    }
  }
}
</style>
